import { render, staticRenderFns } from "./ServerSnapshot.vue?vue&type=template&id=5e53b364"
import script from "./ServerSnapshot.vue?vue&type=script&lang=js"
export * from "./ServerSnapshot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports